export const getUserAgent = () => {
    try {
        return window.navigator.userAgent;
    } catch (e) {
        return '';
    }
};

/**
 * 是否app环境
 * @returns {Boolean} true / false
 */
export const isApp = () => {
    const userAgent = getUserAgent();

    return /FusionKit/i.test(userAgent);
};

/**
 * 是否ios环环境
 * @returns {boolean} true / false
 */
export const isIOS = (): boolean => {
    const userAgent = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    return userAgent;
};

/**
 * 是否global 乘客端环境
 * @returns {Boolean} true / false
 */
export const isGlobalPassenger = () => {
    const userAgent = getUserAgent();

    return isApp() && /passenger/i.test(userAgent);
};

/**
 * 是否是 金融独立端
 * @returns {Boolean} true / false
 */
export const isPrestamos = () => {
    const userAgent = getUserAgent();

    return /com\.didiglobal\.cashloan/i.test(userAgent);
};
